import { apiUrl } from '../../../config/api';
function buildBuscarPartidoUrl(filters) {
    const params = new URLSearchParams();
    const normalizedEtapa = filters.etapa.trim().toLowerCase();
    const normalizedLocalia = filters.localia.trim().toLowerCase();
    const normalizedResultado = filters.resultado.trim().toLowerCase();
    const normalizedAlargue = filters.alargue.trim().toLowerCase();

    if (filters.torneo.trim() !== '') params.append('liga', filters.torneo.trim());

    if (normalizedEtapa !== '') {
        switch (normalizedEtapa) {
            case 'temporada regular':
                params.append('playoffs', 'false');
                break;
            case 'super liga':
                params.append('superLiga', 'true');
                break;
            case 'liguilla':
                params.append('liguilla', 'true');
                break;
            case 'reclasificatorio':
                params.append('reclasificatorio', 'true');
                break;
            case 'playoffs':
                params.append('playoffs', 'true');
                break;
            case 'play-in':
                params.append('playoffsEtapa', 'Play-in');
                break;
            case 'cuartos de final':
                params.append('playoffsEtapa', 'Cuartos de final');
                break;
            case 'semifinal':
                params.append('playoffsEtapa', 'Semifinal');
                break;
            case 'final':
                params.append('playoffsEtapa', 'Final');
                break;
            default:
                break;
        }
    }

    if (filters.cancha.trim() !== '') params.append('cancha', filters.cancha.trim());
    if (filters.adversario.trim() !== '') params.append('adversario', filters.adversario.trim());

    if (normalizedLocalia === 'local') params.append('local', 'true');
    if (normalizedLocalia === 'visitante') params.append('local', 'false');

    if (normalizedResultado === 'ganado') params.append('ganado', 'true');
    if (normalizedResultado === 'perdido') params.append('ganado', 'false');

    if (normalizedAlargue === 'si') params.append('alargue', 'true');
    if (normalizedAlargue === 'no') params.append('alargue', 'false');

    const query = params.toString();

    return query
        ? apiUrl(`busqueda?${query}`)
        : apiUrl('busqueda');
}

export default buildBuscarPartidoUrl;
